import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, UserDefinedLayout1 } from './Layout';

function UserDefinedTab1(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});


    const handleAdditionalFormLoad = useCallback(() => {

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <FormField
                currrentUser={currentUser}
                layoutId='847B23EC-DA0B-4643-B8DD-EF0C2009F0CC'
                layoutName='OMSalesOrderDataEntryAdditionalForm'
                defaultFormSchema={UserDefinedLayout1}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedTab1);
